import React from "react";  
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faHome, 
  faChevronRight, 
  faCreditCard, 
  faShoppingCart,
  faServer,
  faEnvelope,
  faSignature,
  faLock,
  faShieldAlt,
  faBox
} from "@fortawesome/free-solid-svg-icons";

const routes = [
  { path: "/", breadcrumb: "Beranda", icon: faHome },
  { path: "/orderdomain", breadcrumb: "Pesan Domain", icon: faServer },
  { path: "/orderhosting", breadcrumb: "Pesan Hosting", icon: faServer },
  { path: "/migrasihosting", breadcrumb: "Migrasi Hosting", icon: faServer },
  { path: "/ordervps", breadcrumb: "Pesan VPS", icon: faServer },
  { path: "/orderserver", breadcrumb: "Pesan Server", icon: faServer },
  { path: "/orderemailsuite", breadcrumb: "Pesan Email Suite", icon: faEnvelope },
  { path: "/ordersignature", breadcrumb: "Pesan Digital Signature", icon: faSignature },
  { path: "/orderdomainbackorder", breadcrumb: "Pesan Domain Backorder", icon: faServer },
  { path: "/orderdiegovpn", breadcrumb: "Pesan VPN", icon: faShieldAlt },
  { path: "/orderssl", breadcrumb: "Pesan SSL", icon: faLock },
  { path: "/orderproduct", breadcrumb: "Pesan Product", icon: faBox },
  { path: "/orderobjectstorage", breadcrumb: "Pesan Object Storage", icon: faServer },
  { path: "/upgrade", breadcrumb: "Upgrade Service", icon: faServer },
  { path: "/paymentmethod", breadcrumb: "Metode Pembayaran", icon: faCreditCard },
  { path: "/ordersummary", breadcrumb: "Checkout", icon: faShoppingCart },
];

const Breadcrumbs = () => {
  const location = useLocation();
  const { orderProcessName, orderParams } = useSelector((state) => state.cart);

  // Ambil query parameter dari URL
  // const searchParams = new URLSearchParams(location.search);
  // const pid = searchParams.get("pid");
  // const billingcycle = searchParams.get("billingcycle");

  // Tentukan secondary route
  let secondRoute = null;
  let secondRouteLabel = "";
  let secondRouteIcon = faServer;
  if (orderProcessName) {
    const found = routes.find(
      (r) =>
        (orderProcessName === "domain" && r.path === "/orderdomain") ||
        (orderProcessName === "hosting" && r.path === "/orderhosting") ||
        (orderProcessName === "migrasiHosting" && r.path === "/migrasihosting") ||
        (orderProcessName === "vps" && r.path === "/ordervps") ||
        (orderProcessName === "server" && r.path === "/orderserver") ||
        (orderProcessName === "emailsuite" && r.path === "/orderemailsuite") ||
        (orderProcessName === "digitalSignature" && r.path === "/ordersignature") ||
        (orderProcessName === "domainBackorder" && r.path === "/orderdomainbackorder") ||
        (orderProcessName === "diegoVpn" && r.path === "/orderdiegovpn") ||
        (orderProcessName === "ssl" && r.path === "/orderssl") ||
        (orderProcessName === "others" && r.path === "/orderproduct") ||
        (orderProcessName === "objectStorage" && r.path === "/orderobjectstorage") ||
        (orderProcessName === "upgrade" && r.path === "/upgrade")
    );
    if (found) {
      secondRoute = found.path;
      secondRouteLabel = found.breadcrumb;
      secondRouteIcon = found.icon;
    }
  }

  // Siapkan query string jika perlu
  let secondRouteQuery = "";
  if (
    secondRoute &&
    secondRoute !== "/orderdomain" &&
    orderParams?.pid &&
    orderParams?.billingcycle
  ) {
    secondRouteQuery = `?pid=${encodeURIComponent(orderParams.pid)}&billingcycle=${encodeURIComponent(orderParams.billingcycle)}`;
  }

  // Breadcrumbs hanya untuk path yang valid
  const crumbs = [
    {
      to: "/",
      label: "Beranda",
      icon: faHome,
      className: "breadcrumb-link-secondary text-center"
    }
  ];

  if (
    secondRoute &&
    location.pathname !== "/" &&
    location.pathname !== secondRoute &&
    routes.some((r) => r.path === secondRoute)
  ) {
    crumbs.push({
      to: secondRoute + secondRouteQuery,
      label: secondRouteLabel,
      icon: secondRouteIcon,
      className: "breadcrumb-link-secondary"
    });
  }

  if (
    (location.pathname === "/paymentmethod" || location.pathname === "/ordersummary") &&
    routes.some((r) => r.path === "/paymentmethod")
  ) {
    crumbs.push({
      to: "/paymentmethod",
      label: "Metode Pembayaran",
      icon: faCreditCard,
      className: "breadcrumb-link-secondary"
    });
  }

  if (
    location.pathname === "/ordersummary" &&
    routes.some((r) => r.path === "/ordersummary")
  ) {
    crumbs.push({
      to: "/ordersummary",
      label: "Checkout",
      icon: faShoppingCart,
      className: "fw-bold breadcrumb-link-active"
    });
  } else if (
    location.pathname !== "/" &&
    location.pathname !== secondRoute &&
    location.pathname !== "/paymentmethod" &&
    routes.some((r) => r.path === location.pathname)
  ) {
    const found = routes.find((r) => r.path === location.pathname);
    if (found && found.path !== secondRoute) {
      crumbs.push({
        to: found.path,
        label: found.breadcrumb,
        icon: found.icon,
        className: "fw-bold breadcrumb-link-active"
      });
    }
  }

  // Bold untuk step terakhir
  crumbs.forEach((c, i) => {
    if (i === crumbs.length - 1) {
      c.className = "fw-bold breadcrumb-link-active";
    }
  });

  // Jika path tidak ada di routes, hanya tampilkan Beranda
  if (!routes.some((r) => r.path === location.pathname) && location.pathname !== "/" && location.pathname !== secondRoute) {
    return null;
  }

  // Cek jika sedang di payment atau summary, Beranda jadi non-link
  const isNonLinkHome = location.pathname === "/paymentmethod" || location.pathname === "/ordersummary";

  return (
    <nav aria-label="breadcrumb" className="mb-4 breadcrumb-nav">
      <ol className="breadcrumb bg-white px-2 px-md-3 py-2 rounded shadow-sm mb-0">
        <div className="d-flex align-items-center justify-content-center flex-wrap gap-1 breadcrumb-container">
          {crumbs.map((crumb, idx) => (
            <li
              key={crumb.to}
              className={`d-flex align-items-center breadcrumb-item ${idx === crumbs.length - 1 ? "active" : ""}`}
              aria-current={idx === crumbs.length - 1 ? "page" : undefined}
            >
              {idx !== 0 && (
                <FontAwesomeIcon 
                  icon={faChevronRight} 
                  className="breadcrumb-separator mx-1 mx-md-2 text-muted" 
                  size="sm" 
                />
              )}
              {/* Jika Beranda dan sedang di payment/summary, tampilkan span, bukan NavLink */}
              {idx === 0 && isNonLinkHome ? (
                <span className={`d-flex align-items-center rounded-3 px-2 px-md-2 py-1 breadcrumb-link ${crumb.className}`}>
                  {crumb.icon && <FontAwesomeIcon icon={crumb.icon} className="breadcrumb-icon me-1" size="sm" />}
                  <span className="breadcrumb-text">{crumb.label}</span>
                </span>
              ) : idx !== crumbs.length - 1 ? (
                <NavLink 
                  to={crumb.to} 
                  className={`d-flex align-items-center rounded-3 px-2 px-md-2 py-1 text-decoration-none breadcrumb-link ${crumb.className}`}
                  style={{ transition: 'all 0.2s ease' }}
                >
                  {crumb.icon && <FontAwesomeIcon icon={crumb.icon} className="breadcrumb-icon me-1" size="sm" />}
                  <span className="breadcrumb-text">{crumb.label}</span>
                </NavLink>
              ) : (
                <span className={`d-flex align-items-center rounded-3 px-2 px-md-2 py-1 breadcrumb-link ${crumb.className}`}>
                  {crumb.icon && <FontAwesomeIcon icon={crumb.icon} className="breadcrumb-icon me-1" size="sm" />}
                  <span className="breadcrumb-text">{crumb.label}</span>
                </span>
              )}
            </li>
          ))}
        </div>
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
